
const Utils = {
    Dispatch: (t, delay, data)=> {
        setTimeout(function(){
            window.dispatchEvent(new CustomEvent(t, { detail: data }));
        }, delay || 0);
    },

    Post: (url, data)=> {
        console.log(`[app] posting to: ${url}`, data);
        return new Promise(function (resolve, reject) {
            $.post(url, data, function (response, err) {
                let json;
                if (typeof response === "string") {
                    json = JSON.parse(response);
                } else {
                    json = response;
                }

                resolve(json);
            });
        });
    },

    Convert: (src, outputFormat) => {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.crossOrigin = 'Anonymous';
            img.onload = function () {
                var canvas = document.createElement('CANVAS');
                var ctx = canvas.getContext('2d');
                var dataURL;
                canvas.height = this.naturalHeight;
                canvas.width = this.naturalWidth;
                ctx.drawImage(this, 0, 0);
                dataURL = canvas.toDataURL(outputFormat);
                if (dataUrl) {
                    resolve(dataUrl);
                } else {
                    reject();
                }
            };
            img.src = src;
            if (img.complete || img.complete === undefined) {
                img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
                img.src = src;
            }
        });
    }
}

export default Utils;
window.Utils = Utils;
window.Dispatch = Dispatch;

export const Post = Utils.Post;
export const Convert = Utils.Convert;
export const Dispatch = Utils.Dispatch;
